import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getValidationForm = proId =>
  call(websocketFetch, 'get_validation_form', { user_id: proId });
